import MarketingStatus from 'enums/marketingStatus';

/**
 * Checks if the marketingStatus has the Coming Soon (C) code.
 * @param {string} marketingStatus The status of the community.
 * @returns a flag indicating whether marketing Status has Coming Soon or not.
 */
export function isComingSoon(marketingStatus) {
  const statusArray = marketingStatus?.split?.(',');

  return statusArray?.some((key) => MarketingStatus.fromKey(key) === MarketingStatus.ComingSoon);
}

/**
 * Checks if the marketingStatus has the Close Out (X) code.
 * @param {string} marketingStatus The status of the community.
 * @returns a flag indicating whether marketing Status has Close Out or not.
 */
export function isCloseOut(marketingStatus) {
  const statusArray = marketingStatus?.split?.(',');

  return statusArray?.some((key) => MarketingStatus.fromKey(key) === MarketingStatus.CloseOut);
}

/**
 * Checks if the marketingStatus has the Grand Opening (G) code.
 * @param {string} marketingStatus The status of the community.
 * @returns a flag indicating whether marketing Status has Grand Opening or not.
 */
export function isGrandOpening(marketingStatus) {
  const statusArray = marketingStatus?.split?.(',');

  return statusArray?.some((key) => MarketingStatus.fromKey(key) === MarketingStatus.GrandOpening);
}

/**
 * Checks if the marketingStatus has the Active (N) code.
 * @param {string} marketingStatus The status of the community.
 * @returns a flag indicating whether marketing Status has Active or not.
 */
export function isActive(marketingStatus) {
  const statusArray = marketingStatus?.split?.(',');

  return statusArray?.some((key) => MarketingStatus.fromKey(key) === MarketingStatus.Active);
}